import { useState, useEffect } from 'react';
import useDataBean from '../../../../../../../core/services/dataBean/useDataBean';
import { _UBLInvoice } from '../../../../../../../core/services/dataBean/EntityCatalog';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}

export const SelectUBLSoftwareDispatcherByEnvironmentType = ({ idSelector, onChange, label }: Props) => {

    const ubl = useDataBean(_UBLInvoice);
    const [item, setItem] = useState<any>(null);

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        ubl.instance.getUBLSoftwareDispatcherByEnvironmentType(null).then(
            (resp: any) => {

                console.log("RESP REAL:", resp);

                // 🔥 IMPORTANTE: ya estás en DataBeanProperties
                const data = resp;

                console.log("DATA EXTRAÍDA:", data);

                setItem(data);

                if (data && onChange) {
                    onChange(data.IDUBLSoftwareDispatcher);
                }
            }
        );
    };

    return (
        <>
            <label>{label ?? "Software de Facturación:"}</label>

            <input
                className="form-control"
                value={item?.EnvironmentTypeName || ""}
                readOnly
            />
        </>
    );
};